/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DownloadFileInfo
 */
export interface DownloadFileInfo {
    /**
     * 
     * @type {string}
     * @memberof DownloadFileInfo
     */
    content?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DownloadFileInfo
     */
    contentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DownloadFileInfo
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DownloadFileInfo
     */
    sourceType?: string | null;
}

export function DownloadFileInfoFromJSON(json: any): DownloadFileInfo {
    return DownloadFileInfoFromJSONTyped(json, false);
}

export function DownloadFileInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DownloadFileInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : json['content'],
        'contentType': !exists(json, 'contentType') ? undefined : json['contentType'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'sourceType': !exists(json, 'sourceType') ? undefined : json['sourceType'],
    };
}

export function DownloadFileInfoToJSON(value?: DownloadFileInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content,
        'contentType': value.contentType,
        'fileName': value.fileName,
        'sourceType': value.sourceType,
    };
}


